import { render, staticRenderFns } from "./directory.vue?vue&type=template&id=065383dc&scoped=true"
import script from "./directory.vue?vue&type=script&lang=js"
export * from "./directory.vue?vue&type=script&lang=js"
import style0 from "./directory.vue?vue&type=style&index=0&id=065383dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065383dc",
  null
  
)

export default component.exports